import { Icon } from 'components';
import PropTypes from 'prop-types';
import React from 'react';
import { UiOutlineButton, UiInlineFlex } from './OutlineButton.style';


/**
 * button to outline style
 */

export const OutlineButton = ({
  buttoncolor = 'normal',
  children,
  onClick,
  disabled = false,
  loading = false,
  size,
  icon,
  textColor,

}) => {
  const clickEvent = (!loading && !disabled) ? onClick : () => { };

  return (
    <UiOutlineButton
      variant="outlined"
      size={size}
      textColor={buttoncolor === 'cancel' ? '#3a4052' : textColor}
      buttoncolor={disabled ? 'disable' : buttoncolor}
      onClick={clickEvent}
    >
      {icon && <UiInlineFlex buttoncolor={buttoncolor}><Icon.Svg name={icon} color="#fff" /></UiInlineFlex>}
      {children}
    </UiOutlineButton>
  );
};

OutlineButton.propTypes = {
  buttoncolor: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  size: PropTypes.number,
  icon: PropTypes.string,
  textColor: PropTypes.string,
};


